'use client'

import { cn } from '@/core/lib/utils/cn'
import { Link, usePathname } from '@/i18n/navigation'
import { LinkProps } from 'next/link'

type ClassNameProps = {
  active?: string
  inactive?: string
  main?: string
}

type Props = {
  href: LinkProps['href']
  className?: string | ClassNameProps
  exact?: boolean
} & (
    | {
        children: React.ReactNode
        renderLink?: never
      }
    | {
        children?: never
        renderLink: (props: { isActive: boolean }) => React.ReactNode
      }
  )

export const NavLink = ({
  href,
  className = '',
  children,
  renderLink,
  exact
}: Props) => {
  const pathname = usePathname()
  const isActive =
    pathname === href ||
    (typeof href === 'string' &&
      (exact ? pathname === href : pathname.includes(href)))

  const computedClassName =
    typeof className === 'string'
      ? className
      : isActive
        ? (cn(className?.active, className.main) ?? '')
        : (cn(className?.inactive, className.main) ?? '')

  return (
    <Link href={href} className={computedClassName} >
      {children ? children : renderLink?.({ isActive })}
    </Link>
  )
}
